import script from "./new_expiration_submission_form.vue?vue&type=script&setup=true&lang=js"
export * from "./new_expiration_submission_form.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__